export default __webpack_public_path__ + "static/media/wv-icon-profile.d5335ae9.svg";